import React from 'react'

interface IconProps {
    size?: number
    color?: string
}

export const PlayIcon: React.FC<IconProps> = ({ size = 14, color = 'currentColor' }) => (
    <svg width={size} height={size} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.2 2.7v8.6L11.3 7 4.2 2.7Z" fill={color} />
    </svg>
)

export const PauseIcon: React.FC<IconProps> = ({ size = 14, color = 'currentColor' }) => (
    <svg width={size} height={size} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 3h2v8H4V3Zm4 0h2v8H8V3Z" fill={color} />
    </svg>
)

interface VoiceWaveIconProps extends IconProps {
    frame: 0 | 1 | 2
}

export const VoiceWaveIcon: React.FC<VoiceWaveIconProps> = ({ size = 16, color = 'currentColor', frame }) => (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="4" cy="8" r="1.4" fill={color} />
        {frame >= 1 && (
            <path
                d="M7.1 5.4a3.6 3.6 0 0 1 0 5.2"
                stroke={color}
                strokeWidth="1.4"
                strokeLinecap="round"
                fill="none"
            />
        )}
        {frame >= 2 && (
            <path
                d="M10.2 3.6a6.2 6.2 0 0 1 0 8.8"
                stroke={color}
                strokeWidth="1.4"
                strokeLinecap="round"
                fill="none"
            />
        )}
    </svg>
)
